module.exports = __webpack_public_path__ + "static/media/facebook-icon.2874aa8b.svg";